import type { RouteProps } from 'react-router-dom'
import type { PageContext, TemplateName } from '@which/glide-ts-types'

import { accountRoutes } from './account/account.routes'
import { articlePageRoutes } from './article'
import { campaignsRoutes } from './campaigns/campaigns.routes'
import { consumerRightsRoutes } from './consumer-rights/consumer-rights.routes'
import { energyRoutes } from './energy/energy.routes'
import { homeRoutes } from './home/home.routes'
import { hubsRoutes } from './hubs/hubs.routes'
import { liveReportsRoutes } from './live-reports/live-reports.routes'
import { marketingHubRoutes } from './marketing-hub/marketing-hub.routes'
import { moneyRoutes } from './money/money.routes'
import { newsRoutes } from './news/news.routes'
import { policyAndInsightRoutes } from './policy-and-insight/policy-and-insight.routes'
import { reviewRoutes } from './reviews/reviews.routes'
import { savedRoutes } from './saved/saved.routes'
import { signupCompleteRoutes } from './signup-complete/signup-complete.routes'
import { toolFrameworkRoutes } from './tool/tool.routes'
import { verticalPageRoutes } from './vertical'

export type WCDRouteProps = (RouteProps & {
  live: boolean
  prod?: boolean
  preprod?: boolean
})[]

export const routes: WCDRouteProps = [
  ...accountRoutes,
  ...articlePageRoutes,
  ...verticalPageRoutes,
  ...campaignsRoutes,
  ...consumerRightsRoutes,
  ...energyRoutes,
  ...homeRoutes,
  ...hubsRoutes,
  ...liveReportsRoutes,
  ...marketingHubRoutes,
  ...moneyRoutes,
  ...newsRoutes,
  ...policyAndInsightRoutes,
  ...reviewRoutes,
  ...savedRoutes,
  ...signupCompleteRoutes,
  ...toolFrameworkRoutes,
]

type PagePath =
  | 'article-listing/ArticleListingPage'
  | 'article/AboutWhichArticlePage'
  | 'article/PensionArticlePage'
  | 'article/PIArticlePage'
  | 'article/ReviewsAdviceSinglePage'
  | 'article/ReviewsAdviceMultiPage'
  | 'article/NewsArticlePage'
  | 'article/ConsumerRightsPage'
  | 'article/ConsumerRightsCarAdviceToolPage'
  | 'article/ConsumerRightsScamsPage'
  | 'article/FreeAccountArticlePage'
  | 'article/NonCommercialArticlePage'
  | 'author/AuthorPage'
  | 'cr-article-type/ArticleTypePage'
  | 'energy/EnergyPage'
  | 'home/HomePage'
  | 'live-report/LiveReportPage'
  | 'marketing-hub/MarketingHubPage'
  | 'product-hub/ProductHubPage'
  | 'reviews/product-comparison/ProductComparisonPage'
  | 'reviews/product-listing/ProductListingPage'
  | 'reviews/product-page/ProductPage'
  | 'saved/SavedPage'
  | 'search-results/SearchResultsPage'
  | 'signup-complete/SignupCompletePage'
  | 'sub-vertical/SubVerticalPage'
  | 'tool-framework/ToolFrameworkPage'
  | 'vertical/ReviewsPage'
  | 'vertical/NewsPage'
  | 'vertical/NewsListingPage'
  | 'vertical/PolicyAndInsightPage'
  | 'vertical/ConsumerRightsPage'
  | 'vertical/CampaignsPage'
  | 'vertical/AppointmentsPage'
  | 'vertical/SitemapPage'
  | 'vertical/AboutWhichPage'
  | 'vertical/PensionsPage'
  | 'vertical/BrandCampaignPage'

export type PageParams = {
  verticalSlug: string
  subVerticalSlug: string
  categorySlug: string
  superCategorySlug: string
  collectionSlug: string
  articleName: string
  articleSlug: string
  articleType: 'advice' | 'letter' | 'regulation'
  articleTypeSlug: 'letters' | 'regulations'
  toolSlug: 'used-car'
  toolPage: string
  filterSlug: string
  filterValue: string
  searchResultsSlug: string
  searchResultsPage: string
  authorSlug: string
  authorPage: string
  productSlug: string
  productHubSlug: string
  liveReportSlug: string
  taxonomySlug: string
}

export type ArticleType = PageParams['articleType']

export type PageProps = {
  pagePath: PagePath
  template?: TemplateName
  rootCollectionName?: string
  context?: PageContext
}
